import React, { memo, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { selectionStoreChangesService } from "../../services/selection-store-changes.service";
import { moduleSettings } from "../../stores/module-settings.store";
import { selectionStore } from "../../stores/selection.store";
import { GolEventListener } from "../calendar/calendar";
import { Dropdown } from "../dropdown/dropdown";
import {
  stringArrayToDropdown,
  stringToDropdown,
} from "../dropdown/dropdown-transform";
import filterService from "../../services/filters.service";

interface IStyle {
  forceAreaSelection: Boolean;
}

interface IFilters {
  alignPosition: FiltersPosition;
  shouldForceAreaSelection?: Boolean | false;
}

export enum FiltersPosition {
  start = "start",
  center = "center",
}

const FilterStyle = styled.div<IStyle>`
  display: flex;
  flex-direction: ${(props) =>
    props.forceAreaSelection ? "row-reverse" : "row"};
  width: 100%;
  justify-content: ${(props) => props.theme.alignPosition};
  align-items: start;
  text-align: center;
  margin-bottom: 30px;

  & > div {
    margin-left: 4px;
    margin-right: 4px;
  }

  #mui-component-select-outline {
    width: 254px;
    text-align: left;
  }

  .MuiOutlinedInput-input {
    padding-left: 16px;
  }

  @media screen and (max-width: 662px) {
     {
      flex-direction: ${(props) =>
        props.forceAreaSelection ? "column-reverse" : "column"};
      align-items: center;
      align-content: center;
    }

    & > div {
      margin-left: 0;
      margin-right: 0;
    }

    > * {
      &:first-child {
        margin-bottom: 8px;
      }
    }
  }

  @media screen and (max-width: 480px) {
    > * {
      flex: 0 0 100%;
      margin-bottom: 10px;
      margin-left: 0;
      margin-right: 0;
    }
  }
`;

const FiltersWrapper = (props: IFilters) => {
  const { t } = useTranslation();

  const periodChanged = (value: any) => {
    if (selectionStore.period !== value) {
      selectionStore.period = value;
      selectionStoreChangesService.dispatch(GolEventListener.Period);
    }
  };

  const areaChanged = (value: any) => {
    if (selectionStore.area !== value) {
      selectionStore.area = value;
      selectionStoreChangesService.dispatch(GolEventListener.Area);
    }
  };

  const periodsOptions = stringArrayToDropdown(
    moduleSettings.periods,
    selectionStore.period,
    "periods."
  );
  const areasOptions = filterService.areaDropdownOptions(
    moduleSettings.areas,
    selectionStore.area
  );
  const forceAreaSelection = moduleSettings.forceAreaSelection;
  const areaPlaceholder = forceAreaSelection ? "placeholder" : "all";
  const hideServiceSelection = moduleSettings.hideServiceSelection;

  return (
    <FilterStyle
      data-test="filters"
      theme={props}
      forceAreaSelection={forceAreaSelection}
    >
      {!hideServiceSelection &&
        periodsOptions.length > 1 &&
        !props.shouldForceAreaSelection && (
          <Dropdown
            dataTest="dropdownPeriods"
            options={periodsOptions}
            placeholderOption={stringToDropdown("all", null, "periods.")}
            placeholderSelectable={true}
            onItemClick={periodChanged}
          />
        )}
      {areasOptions ? (
        <Dropdown
          requiredWithPlaceholder={forceAreaSelection}
          dataTest="dropdownAreas"
          options={areasOptions}
          placeholderOption={stringToDropdown(areaPlaceholder, null, "rooms.")}
          placeholderSelectable={!forceAreaSelection}
          onItemClick={areaChanged}
        />
      ) : (
        ""
      )}
    </FilterStyle>
  );
};

export const Filters = memo(FiltersWrapper);
